<template>
    <div class="filtres-axiomes" v-if="hasLogicalAxiomes || hasAnonymousAxiomes">

        <div class="text-break" style="padding-right: 20px;">
            Afficher les concepts
        </div>

        <label v-if="hasAnonymousAxiomes">
            <input type="checkbox" :checked="anonymousAxiomesChecked" @change="onAnonymousAxiomesChange($event)"
                style="margin-right: 10px;" />
        </label>
        <div v-if="hasAnonymousAxiomes" class="text-break">
            avec annotation anonyme
        </div>

        <label v-if="hasLogicalAxiomes">
            <input type="checkbox" :checked="logicalAxiomesChecked" @change="onLogicalAxiomesChange($event)"
                style="margin-right: 10px;" />
        </label>
        <div v-if="hasLogicalAxiomes" class="text-break">
            avec axiome logique
        </div>

        <div class="text-break ml-auto" v-text="details" />
    </div>
</template>


<script>
import ConceptsStore from "../concepts-store";

export default {
    name: "FiltresAxiomes",
    // plus de props, tout est géré en data
    data() {
        return {
            store: ConceptsStore.state,
            configurationsFiltresAxiomes: [],
            logicalAxiomesChecked: false,
            anonymousAxiomesChecked: false,
            hasLogicalAxiomes: true,
            hasAnonymousAxiomes: true,
            nbAxiomesAnonymes: 0,
            nbAxiomesLogiques: 0
        };
    },
    created() {
        this.purgeOldConfigurations();
        this.initConfigurations();
        this.saveConfigurations();
    },
    computed: {
        /**
         * Retourne le détail des axiomes
         * @returns {String}    Le détail des axiomes
         */
        details() {
            const anonymousAxiomesText = this.nbAxiomesAnonymes > 1 ? 'annotations anonymes' : 'annotation anonyme';
            const logicalAxiomesText = this.nbAxiomesLogiques > 1 ? 'axiomes logiques' : 'axiome logique';
            const content = `Il existe ${this.nbAxiomesAnonymes} ${anonymousAxiomesText} et ${this.nbAxiomesLogiques} ${logicalAxiomesText}`;
            return content;
        }
    },
    methods: {
        /**
         * Met à jour les informations des axiomes
         * @param {Number} nbAxiomesAnonymes    Le nombre d'axiomes anonymes
         */
        updateInformation(nbAxiomesAnonymes, nbAxiomesLogiques) {
            this.nbAxiomesAnonymes = nbAxiomesAnonymes;
            this.nbAxiomesLogiques = nbAxiomesLogiques;
        },

        hideAnonymousAxiomes() {
            // Hide all elements with class 'blank-node-0'
            const blankNodes = document.querySelectorAll('.blanknode-annonymous-container-level0');
            blankNodes.forEach(el => {
                // Get nearest parent with class 'attribute-display-container' and add class 'logical-axiome-hidden'
                const parent = el.closest('.attribute-display-container');
                if (parent) {
                    parent.classList.add('annonymous-axiome-hidden');
                }
            });
        },

        showAnonymousAxiomes() {
            // Hide all elements with class 'blank-node-0'
            const blankNodes = document.querySelectorAll('.blanknode-annonymous-container-level0');
            blankNodes.forEach(el => {
                const parent = el.closest('.attribute-display-container');
                if (parent) {
                    parent.classList.remove('annonymous-axiome-hidden');
                }
            });
        },

        hideLogicalAxiomes() {
            // Hide all elements with class 'blank-node-0'
            const blankNodes = document.querySelectorAll('.blanknode-logic-container-level0');
            blankNodes.forEach(el => {
                // Get nearest parent with class 'attribute-display-container' and add class 'logical-axiome-hidden'
                const parent = el.closest('.attribute-display-container');
                if (parent) {
                    parent.classList.add('logical-axiome-hidden');
                }
            });
        },

        showLogicalAxiomes() {
            // Hide all elements with class 'blank-node-0'
            const blankNodes = document.querySelectorAll('.blanknode-logic-container-level0');
            blankNodes.forEach(el => {
                const parent = el.closest('.attribute-display-container');
                if (parent) {
                    parent.classList.remove('logical-axiome-hidden');
                }
            });
        },


        updateAxiomesStatus() {
            if (!this.logicalAxiomesChecked) {
                this.hideLogicalAxiomes();
            } else {
                this.showLogicalAxiomes();
            }

            if (!this.anonymousAxiomesChecked) {
                this.hideAnonymousAxiomes();
            } else {
                this.showAnonymousAxiomes();
            }

            this.saveConfigurations();
        },

        afterChangeFilterChange() {
            this.updateAxiomesStatus();
            this.store.configurationsFiltresAxiomesChange = !this.store.configurationsFiltresAxiomesChange;
        },

        /**
         * Gère le changement de l'état de la checkbox des axiomes logiques
         */
        onLogicalAxiomesChange(event) {
            if (event !== undefined && event.target !== undefined) {
                const newValue = event.target.checked;
                this.logicalAxiomesChecked = newValue;
            }
            this.afterChangeFilterChange();
        },

        onAnonymousAxiomesChange(event) {
            if (event !== undefined && event.target !== undefined) {
                const newValue = event.target.checked;
                this.anonymousAxiomesChecked = newValue;
            }
            this.afterChangeFilterChange();
        },

        /**
         * purge les vieilles configurations des filtres en local storage
         */
        purgeOldConfigurations() {
            const configurationsFiltresAxiomes = JSON.parse(localStorage.getItem('configurationsFiltresAxiomes'));
            if (configurationsFiltresAxiomes) {
                const today = new Date();
                const filteredConfigurations = configurationsFiltresAxiomes.filter(config => {
                    const limitDate = new Date(config.configuration.date);
                    limitDate.setDate(limitDate.getDate() + 1);
                    return limitDate >= today;
                });
                this.configurationsFiltresAxiomes = filteredConfigurations;
                localStorage.setItem('configurationsFiltresAxiomes', JSON.stringify(this.configurationsFiltresAxiomes));
            }
        },

        /**
         * Initialise les configurations des filtres
         */
        initConfigurations() {
            let configurationDeLaTerminologieTrouvee = false;
            this.configurationsFiltresAxiomes = JSON.parse(localStorage.getItem('configurationsFiltresAxiomes')) || [];
            this.configurationsFiltresAxiomes.forEach(config => {
                if (config.terminologyId === this.store.terminologyId) {
                    this.logicalAxiomesChecked = config.configuration.logicalAxiomesChecked;
                    this.anonymousAxiomesChecked = config.configuration.anonymousAxiomesChecked;
                    configurationDeLaTerminologieTrouvee = true;
                }
            });

            if (configurationDeLaTerminologieTrouvee === false) {
                this.configurationsFiltresAxiomes.push({
                    terminologyId: this.store.terminologyId,
                    configuration: {
                        logicalAxiomesChecked: this.logicalAxiomesChecked,
                        anonymousAxiomesChecked: this.anonymousAxiomesChecked,
                        date: new Date().toISOString()
                    }
                });
                this.saveConfigurations();
            }
            this.updateAxiomesStatus();
        },

        /**
         * Mémorise la configuration des filtres en local storage
         */
        saveConfigurations() {
            this.configurationsFiltresAxiomes.forEach(config => {
                if (config.terminologyId === this.store.terminologyId) {
                    config.configuration.logicalAxiomesChecked = this.logicalAxiomesChecked;
                    config.configuration.anonymousAxiomesChecked = this.anonymousAxiomesChecked;
                    config.date = new Date().toISOString();
                }
            });
            localStorage.setItem('configurationsFiltresAxiomes', JSON.stringify(this.configurationsFiltresAxiomes));
        },
    }
};
</script>



<style scoped>
.filtres-axiomes {
    display: flex;
    flex-direction: row;
}

label {
    display: block;
    margin-bottom: 5px;
    cursor: pointer;
}
</style>